export enum State {
  INIT = 'init',

  VERIFICATION = 'verification',

  USER_PROFILE_SEND = 'user-profile-send',

  SASU_CREATION_EU_BANK_ACCOUNT = 'sasu-creation-eu-bank-account',
  COMPANY_COMPLIANCE = 'company-compliance',

  PERSONAL_COMPLIANCE = 'personal-compliance',

  OBJET_SOCIAL = 'objet-social',
  SEND_OBJET_SOCIAL = 'send-objet-social',

  SASU_CREATION_LANDBOT = 'sasu-creation-landbot',
  SASU_CREATION_LANDBOT_PENDING = 'sasu-creation-landbot-pending',
  SASU_CREATION_LANDBOT_SUCCESS = 'sasu-creation-landbot-success',
  SASU_CREATION_PLAN_CHOICE = 'sasu-creation-plan-choice',

  SASU_CREATION_SUBMIT_APPLICATION = 'sasu-creation-submit-application',

  SASU_CREATION_CREATE = 'sasu-creation-create',

  USER_AGREEMENT = 'user-agreement',
  SASU_CREATION_AGREEMENT = 'sasu-creation-agreement',

  SASU_CREATION_NEXT_STEPS = 'sasu-creation-next-steps',
  APPLICATION_FOLLOW_UP = 'application-follow-up',
  BENEFICIARIES_DOCS = 'beneficiaries-docs',
  DOWNLOAD_SHINE_MESSAGE_SENT = 'download-shine-message-sent',

  ABORT_APPLICATION = 'abort-application',

  DONE = 'done',
  ABORT = 'abort',
}
